import React from "react";
import { useSubscription } from "../contexts/SubscriptionContext";

const SubscriptionStatus: React.FC = () => {
  const { isActive, isLoading, error } = useSubscription();

  if (isLoading) {
    return (
      <div className="p-4 bg-slate-50 dark:bg-gray-950 rounded-xl border border-slate-100 dark:border-gray-800 animate-pulse">
        <div className="h-4 bg-slate-200 dark:bg-gray-800 rounded w-3/4"></div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="p-4 bg-red-50 dark:bg-red-950/30 text-red-600 dark:text-red-400 rounded-xl border border-red-100 dark:border-red-900">
        <p className="text-sm">Unable to check subscription status</p>
      </div>
    );
  }

  if (!isActive) return null;

  return (
    <div className="flex items-center gap-3 p-4 bg-gradient-to-r from-[#47b3fe]/10 to-indigo-500/10 dark:from-blue-950/50 dark:to-indigo-950/50 rounded-xl border border-[#47b3fe]/20 dark:border-blue-900/40">
      <div className="w-8 h-8 rounded-xl bg-gradient-to-br from-[#47b3fe] to-indigo-600 flex items-center justify-center flex-shrink-0">
        <i className="fas fa-crown text-yellow-300 text-xs"></i>
      </div>
      <div className="min-w-0">
        <p className="text-sm font-semibold text-slate-900 dark:text-white">
          Premium Active
        </p>
        <p className="text-xs text-slate-500 dark:text-slate-400 mt-0.5">
          Full access to all features
        </p>
      </div>
    </div>
  );
};

export default SubscriptionStatus;
